import { render, staticRenderFns } from "./login.vue?vue&type=template&id=620a26fc&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=620a26fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a26fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Toast: require('/codebuild/output/src985175027/src/nuxt-thefutures/components/Toast.vue').default})
